enum ClientsAction {
  FETCH_ALL = 'clients/fetchAll',
  CLEAN_SELECTED_CLIENT = 'clients/cleanSelectedClient',
  UPDATE_CLIENT = 'clients/updateClients',
  ADD_CLIENT = 'clients/addClient'
}

export default ClientsAction;
